exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-5df55390]:focus {\n    color: white;\n}\n.btn[data-v-5df55390]:hover {\n    color: var(--purple);\n}\n.vv-error-message[data-v-5df55390] {\n    font-size: 13px;\n    line-height: 20px;\n    text-align: left;\n    color: red;\n}\n", ""]);

// exports
